var _path, _path2, _path3, _path4, _path5, _circle, _circle2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg0800(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 51.3 51.3"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    fill: "#22c4f4",
    d: "M7.7 17.8c-.4.3-3 4-3 4l.2 3.9 1.4 5 1.8 3.2s1 .6 1 1.5 2 2.4 2 2.4l2.2 2.2 3.1 2.5 5.1 2.4 3.7 1.7 3 .3 1.9-.2 2.1-1.3 1.4-1.5v-1.8l-1-2.9-1.6-1.6-1.2-1s0-.2-.7-.2-2.4.7-2.4.7l-1 1-2 .9-2.7-1.3-2.1-2s-2.7-2-2.9-2.2c-.2-.3-1.4-1.7-1.7-2.2-.3-.5-1.4-2.3-1.4-2.3l-.7-1.4 1.7-2.9.7-1 .1-1.9-1-2.2-2.1-1.9H7.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    fill: "#22c4f4",
    d: "M22.1 29l1.9-7.5-.5-9.9s3.4-6.9 7.3-7.4 10.7 1.3 10.7 1.3l4.1 3.9.8 3.8.4 3.9.4 2.5-1.3 3.4-2.9 2.6-4.3 2.2-2.6.6-3.4-.1-2.7-.7-2.9.3-5 1.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h51.3v51.3H0V0z",
    fill: "none"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    className: "st2",
    fill: "none",
    strokeWidth: 3.2083,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    stroke: "#113d64",
    d: "M34.9 28.6c-1.8 0-3.6-.4-5.1-1.1L22.3 29l1.6-7.5c-.7-1.6-1.1-3.3-1.1-5.1 0-6.7 5.4-12.1 12.1-12.1S47 9.7 47 16.4s-5.4 12.2-12.1 12.2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    strokeMiterlimit: 10,
    stroke: "#113d64",
    fill: "none",
    strokeWidth: 3.2083,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M32.5 39.3l-2.1-2.1c-1-1-2.7-1-3.8 0L25 38.8c-.4.4-.9.5-1.4.3-2.4-1-4.7-2.6-6.8-4.7-2.1-2.1-3.6-4.4-4.7-6.8-.2-.5-.1-1.1.3-1.4l1.5-1.5c1.2-1.2 1.2-2.9.2-3.9l-2.1-2c-1.4-1.4-3.6-1.4-5 0L5.9 20c-1.3 1.3-1.9 3.2-1.5 5 .9 4.6 3.6 9.7 7.9 14s9.4 7 14 7.9c1.9.4 3.8-.2 5.1-1.5l1.2-1.2c1.3-1.3 1.3-3.5-.1-4.9z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    fill: "none",
    strokeWidth: 3.2083,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#fff",
    cx: 29.2,
    cy: 16.7,
    r: 0.1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    fill: "none",
    strokeWidth: 3.2083,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#fff",
    cx: 34.7,
    cy: 16.7,
    r: 0.1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    fill: "none",
    strokeWidth: 3.2083,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#fff",
    cx: 40.3,
    cy: 16.7,
    r: 0.1
  })));
}
export default "data:image/svg+xml;base64,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";
export { Svg0800 as ReactComponent };